import { ElementType, Suspense } from 'react';

// project import
import { Loader } from './Loader.js';

// ==============================|| LOADABLE - LAZY LOADING ||============================== //

export const Loadable = (Component: ElementType) => (props: any) => {
  return (
    <Suspense fallback={<Loader />}>
      <Component {...props} />
    </Suspense>
  );
};
